import { ref } from "vue";

// Global state for notifications
const notifications = ref([]);
let notificationId = 0;

export function useNotifications() {
  const addNotification = (notification) => {
    const id = ++notificationId;
    const newNotification = {
      id,
      title: notification.title || "Notification",
      message: notification.message || "",
      type: notification.type || "info", // 'success', 'warning', 'danger', 'info'
      duration: notification.duration || 5000, // milliseconds
      closable: notification.closable !== false, // default to true
      createdAt: Date.now(),
    };

    notifications.value.push(newNotification);

    // Auto-remove notification after duration
    if (newNotification.duration > 0) {
      setTimeout(() => {
        removeNotification(id);
      }, newNotification.duration);
    }

    return id;
  };

  const removeNotification = (id) => {
    const index = notifications.value.findIndex(
      (notification) => notification.id === id
    );
    if (index > -1) {
      notifications.value.splice(index, 1);
    }
  };

  const clearAll = () => {
    notifications.value = [];
  };

  // Convenience methods for different notification types
  const notifySuccess = (title, message, options = {}) => {
    return addNotification({
      title,
      message,
      type: "success",
      ...options,
    });
  };

  const notifyError = (title, message, options = {}) => {
    return addNotification({
      title,
      message,
      type: "danger",
      ...options,
    });
  };

  const notifyWarning = (title, message, options = {}) => {
    return addNotification({
      title,
      message,
      type: "warning",
      ...options,
    });
  };

  const notifyInfo = (title, message, options = {}) => {
    return addNotification({
      title,
      message,
      type: "info",
      ...options,
    });
  };

  return {
    notifications,
    addNotification,
    removeNotification,
    clearAll,
    notifySuccess,
    notifyError,
    notifyWarning,
    notifyInfo,
  };
}
